











































import Vue from 'vue';
import StepContent from '@/components/StepContent.vue';
import BackgroundTools from '@/components/BackgroundTools.vue';

const waitFor = (delay: number) => new Promise(resolve => setTimeout(resolve, delay));

export default Vue.extend<any, any, any, any>({
	components: { StepContent, BackgroundTools },
	data: () => ({
		brain: false,
		nobrain: false,
	}),
	methods: {
		async removeTheBrain() {
			await waitFor(400);
			this.brain = true;
			await waitFor(1200);
			this.nobrain = true;
		},
	},
});
